import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './dropdown.scss'

class Dropdown extends Component {

	constructor() {
		super()

		this.state = {
			keyString: '',
			highlightedElement: -1,
		}
		this.keyTimeout = 0
	}

	componentDidMount() {
		if (this.elementList) {
			this.elementList.focus()
		}
	}

	componentWillUpdate(nextProps, nextState) {
		if (nextState.keyString === this.state.keyString || nextState.keyString === '') {
			return
		}
		const option = this.props.options.find(option => {
			const optionText = option[this.props.text_key] + ''
			if (optionText.toLowerCase().indexOf(nextState.keyString.toLowerCase()) === 0) {
				return true
			}
		})
		if (option) {
			this.setIndexAndScroll(this.props.options.indexOf(option))
		}
	}

	componentWillUnmount() {
		clearTimeout(this.keyTimeout)
	}

	doBlur() {
		if (this.props.onBlur) {
			this.props.onBlur()
		}
	}

	resetKeyString() {
		this.setState({
			keyString: '',
		})
	}

	onMouseOver(option) {
		const index = this.props.options.indexOf(option)
		this.setState({highlightedElement: index})
	}

	setIndexAndScroll(index) {
		this.elementList.scrollTop = index * 40
	}

	doKeyUp(ev) {
		if (ev.keyCode >= 65 && ev.keyCode <= 90 || ev.keyCode !== 32) {
			ev.preventDefault()
			ev.stopPropagation()
			this.setState({
				keyString: this.state.keyString + ev.key,
			})
			clearTimeout(this.keyTimeout)
			this.keyTimeout = setTimeout(this.resetKeyString.bind(this), 1000)
		}
		if (ev.keyCode === 13 && this.state.highlightedElement >= 0) {
			this.props.onElementClick(this.props.options[this.state.highlightedElement])
		} else if (ev.keyCode === 38 && this.state.highlightedElement > 0) {
			this.setIndexAndScroll(this.state.highlightedElement)
		} else if (ev.keyCode === 40 && this.state.highlightedElement < this.props.options.length - 1) {
			this.setIndexAndScroll(this.state.highlightedElement)
		}
	}

	doKeyDown(ev) {
		if (ev.keyCode === 38 && this.state.highlightedElement > 0) {
			this.setState({highlightedElement: this.state.highlightedElement - 1})
			this.setIndexAndScroll(this.state.highlightedElement)
		} else if (ev.keyCode === 40 && this.state.highlightedElement < this.props.options.length - 1) {
			this.setState({highlightedElement: this.state.highlightedElement + 1})
			this.setIndexAndScroll(this.state.highlightedElement)
		}
	}

	render() {
		const ListElements = this.props.options.map((option, index) => (
			<li
				key={option[this.props.key_name]}
				styleName={classNames({
					item: true,
					highlighted: index === this.state.highlightedElement,
				})}
				onMouseOver={() => this.onMouseOver(option)}
				onClick={ () => this.props.onElementClick(option) }
			>
				{option[this.props.text_key]}
			</li>
		))

		return (
			<div styleName='wrapper'>
				<ul
					tabIndex={this.props.tabIndex}
					ref={element => {
						this.elementList = element
					}}
					styleName='box'
					onKeyUp={this.doKeyUp.bind(this)}
					onKeyDown={this.doKeyDown.bind(this)}
					onBlur={this.doBlur.bind(this)}
				>
					{ ListElements }
				</ul>
			</div>
		)
	}
}

Dropdown.propTypes = {
	options: PropTypes.array,
	onElementClick: PropTypes.func,
	key_name: PropTypes.string,
	text_key: PropTypes.string,
	size: PropTypes.string,
}

Dropdown.defaultProps = {
	key_name: 'value',
	text_key: 'text',
	size: 'normal',
}

export default CSSModules(Dropdown, styles, {allowMultiple: true})
